import axiosSmartSurvey from '../../../api/axios';
import Swal from 'sweetalert2';

export default function useAuthentication() {

    // 1. ฟังก์ชันดึงรายชื่อผู้ใช้งาน
    async function fetchUserList(setUserList) {
        try {
            const response = await axiosSmartSurvey({
                method: 'post',
                url: '/authentication/accountslist',
            });

            const resData = response.data;
            if (resData.status === 'OK') {
                setUserList(resData.accountsList);
            } else {
                console.error(`Error: ${resData.message || resData.mesage}`);
            }
        } catch (err) {
            console.error("Fetch user list failed:", err);
        }
    }

    // 2. ฟังก์ชันเปลี่ยนรหัสผ่าน (ใช้ SweetAlert2)
    async function changePassword(event, userId, setChangePasswordModalOpen) {
        const data = new FormData(event.currentTarget);
        const newPassword = data.get('newPassword');
        const confirmNewPassword = data.get('confirmNewPassword');

        // 🔍 Validation เบื้องต้นฝั่ง Client
        if (!newPassword || !confirmNewPassword) {
            Swal.fire({
                icon: 'warning',
                title: 'กรุณากรอกข้อมูลให้ครบถ้วน',
                text: 'กรุณากรอกรหัสผ่านใหม่และยืนยันรหัสผ่าน',
                confirmButtonColor: '#d33',
            });
            return;
        }

        if (newPassword !== confirmNewPassword) {
            Swal.fire({
                icon: 'error',
                title: 'รหัสผ่านไม่ตรงกัน',
                text: 'กรุณาตรวจสอบรหัสผ่านใหม่อีกครั้ง',
                confirmButtonColor: '#d33',
            });
            return;
        }

        const jsonData = {
            userId: userId,
            newPassword: newPassword,
            confirmNewPassword: confirmNewPassword,
        };

        // ⏳ แสดง Loading ขณะยิง API
        Swal.fire({
            title: 'กำลังบันทึกข้อมูล...',
            text: 'กรุณารอสักครู่',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const response = await axiosSmartSurvey({
                method: 'post',
                url: '/authentication/changepassword',
                data: JSON.stringify(jsonData),
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (response?.data?.status === 'OK') {
                // 🟢 แจ้งเตือนสำเร็จ
                Swal.fire({
                    icon: 'success',
                    title: 'เปลี่ยนรหัสผ่านสำเร็จ!',
                    text: response.data.statusText || 'ระบบทำการอัปเดตรหัสผ่านเรียบร้อยแล้ว',
                    confirmButtonColor: '#025464',
                    timer: 2000,
                    showConfirmButton: true
                });

                // ล้างค่าในฟอร์มหลังเซฟสำเร็จ
                if (event.currentTarget) event.currentTarget.reset();
                setChangePasswordModalOpen(false)
            } else {
                // 🔴 แจ้งเตือนข้อผิดพลาดจาก Server
                Swal.fire({
                    icon: 'error',
                    title: 'เปลี่ยนรหัสผ่านไม่สำเร็จ',
                    text: response?.data?.registerError || 'เกิดข้อผิดพลาดจากระบบ',
                    confirmButtonColor: '#d33',
                });
            }
        } catch (err) {
            console.error("Change Password Error:", err);
            // 🔴 แจ้งเตือนกรณี Network หรือ Server Error
            Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาดในการเชื่อมต่อ',
                text: err.response?.data?.message || 'ไม่สามารถติดต่อเครื่องแม่ข่ายได้',
                confirmButtonColor: '#d33',
            });
        }
    }

    return { fetchUserList, changePassword };
}